/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count codon usage in a coding sequence: counts, frequency per 1000 and fraction per amino acid.`)
};

const es_codon_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta el uso de codones en una secuencia codificante: conteos, frecuencia por 1000 y fracción por aminoácido.`)
};

const de_codon_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zählen Sie die Codon-Nutzung in einer Kodierungssequenz: Anzahl, Häufigkeit pro 1000 und Anteil pro Aminosäure.`)
};

const nl_codon_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel het codongebruik in een coderende sequentie: aantallen, frequentie per 1000 en fractie per aminozuur.`)
};

const fr_codon_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptez l'usage des codons dans une séquence codante : décomptes, fréquence pour 1000 et fraction par acide aminé.`)
};

const it_codon_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta l'uso dei codoni in una sequenza codificante: conteggi, frequenza per 1000 e frazione per amminoacido.`)
};

const pt_br2_codon_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte o uso de códons em uma sequência codificante: contagens, frequência por 1000 e fração por aminoácido.`)
};

const pt_codon_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte o uso de codões numa sequência codificante: contagens, frequência por 1000 e fração por aminoácido.`)
};

const ja_codon_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コード配列中のコドン使用頻度を計算します: カウント数、1000あたりの頻度、アミノ酸ごとの割合。`)
};

const zh_codon_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`统计编码序列中密码子的使用情况：计数、每千个密码子频率以及每种氨基酸内的比例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_tool_description", locale)
	if (locale === "en") return en_codon_tool_description(inputs)
	if (locale === "es") return es_codon_tool_description(inputs)
	if (locale === "de") return de_codon_tool_description(inputs)
	if (locale === "nl") return nl_codon_tool_description(inputs)
	if (locale === "fr") return fr_codon_tool_description(inputs)
	if (locale === "it") return it_codon_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_codon_tool_description(inputs)
	if (locale === "pt") return pt_codon_tool_description(inputs)
	if (locale === "ja") return ja_codon_tool_description(inputs)
	return zh_codon_tool_description(inputs)
};